import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/simplybuilt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M481.2 64H375.2C360.7 64 348.6 75.8 348.6 90.3V129.9H163.3V90.3C163.3 75.8 151.3 64 136.7 64H30.7C16.1 64 4.3 75.8 4.3 90.3V421.7C4.3 436.2 16.1 448 30.9 448H481.3C496.1 448 507.9 436.2 507.9 421.7V90.3C507.7 75.8 495.9 64 481.2 64zM149.8 355.8C113.2 355.8 83.4 326.1 83.4 289.4 83.4 252.5 113.1 222.8 149.8 222.8 186.7 222.8 216.4 252.5 216.4 289.4 216.4 326.1 186.7 355.8 149.8 355.8zM362.2 355.8C325.3 355.8 295.6 326.1 295.6 289.2 295.6 252.6 325.3 222.8 362.2 222.8 398.8 222.8 428.6 252.5 428.6 289.2 428.6 326.1 398.8 355.8 362.2 355.8z'
      }
    ]
  }
})
